import {PlainTextOrHtml, intlShape} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';
import {DocumentLink} from 'src/js/containers/file/components/DocumentLink';
import baseLinkFormatterParams from 'src/js/lib/raw_rendering/base_link_formatter_params';

import styles from './LinkFormatter.less';

const STATIC_EMPTY_OBJECT = {};

class LinkFormatter extends React.PureComponent {
  render() {
    const {intl} = this.props;
    const {linkId, newSearchParams, route, titleText, translatedValue, value} = baseLinkFormatterParams(this.props, {intl});

    return value ? (
      <div className={styles.dlLinkFormatter}>
        <DocumentLink docId={linkId} documentDetailRoute={route} titleText={titleText} searchParams={newSearchParams} suppressPadding>
          <PlainTextOrHtml text={translatedValue} showHtml className={styles.dlLinkFormatterText} />
        </DocumentLink>
      </div>
    ) : (
      ''
    );
  }
}

LinkFormatter.displayName = 'LinkFormatter';

/* eslint-disable react/no-unused-prop-types */
LinkFormatter.propTypes = {
  intl: intlShape.isRequired,
  searchParams: PropTypes.objectOf(PropTypes.any),
  useValue: PropTypes.bool,
  route: PropTypes.string.isRequired,
  routeParamId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

LinkFormatter.defaultProps = {
  routeParamId: null,
  searchParams: STATIC_EMPTY_OBJECT,
  text: undefined,
  useValue: false,
  value: undefined,
};

export default injectIntl(LinkFormatter);
